export default {
    en: {
        bata_notice: "PM AutoTwin Beta Period & Plan Transition Notice",
        usage: "Credits",
        used_storage: "Storage",
        avg_reduction: "Average Reduction",
        avg_rating: "Average Rating",

        optimize_history: "Optimization History",
        index_no: "NO",
        file_label: "File Name",
        date_label: "Date",
        status_label: "Status",
        original_size_label: "Original Size",
        optimized_size_label: "Optimized Size",
        optimized_output_label: "Output Format",
        reduction_label: "Reduction",
        rating_label: "Rating",
        download_label: "Download",
        share_label: "공유하기",
        status_success: "Success",
        status_optimizing: "Optimizing...",
        status_fail: "Fail",

        count_label: "Credits",

        expire_days: "Expires in {0} days",
        reset_expire_days: "Reset in {0} days",
        reset_expire_day: "Reset in {0} day",
        avg_reduction_info: "Average {0}% vertex reduction",
        avg_rating_info: "Based on {0} reviews",
    },
    ko: {
        bata_notice: "PM AutoTwin 베타 이용 기간 및 플랜 전환 안내",
        usage: "크레딧",
        used_storage: "스토리지",
        avg_reduction: "평균 감소율",
        avg_rating: "평균 만족도",

        optimize_history: "최적화 기록",
        index_no: "NO",
        file_label: "파일 이름",
        date_label: "작업 날짜",
        status_label: "상태",
        original_size_label: "원본 크기",
        optimized_size_label: "최적화 크기",
        optimized_output_label: "출력 포맷",
        reduction_label: "감소율",
        rating_label: "최적화 평가",
        download_label: "다운로드",
        share_label: "공유하기",
        status_success: "성공",
        status_optimizing: "최적화 중...",
        status_fail: "실패",

        expire_days: "{0}일 남음",
        reset_expire_days: "{0}일 후 초기화",
        reset_expire_day: "{0}일 후 초기화",
        avg_reduction_info: "버텍스 수 평균 {0}% 감소",
        avg_rating_info: "최적화 평가 {0}건 기준",

        count_label: "크레딧",

    },
    ja: {
        bata_notice: "PM AutoTwin ベータ利用期間およびプラン移行のご案内",
        usage: "クレジット",
        used_storage: "ストレージ",
        avg_reduction: "平均削減率",
        avg_rating: "平均満足度",

        optimize_history: "最適化履歴",
        index_no: "NO",
        file_label: "ファイル名",
        date_label: "作成日時",
        status_label: "ステータス",
        original_size_label: "元のサイズ",
        optimized_size_label: "最適化サイズ",
        optimized_output_label: "出力形式",
        reduction_label: "削減率",
        rating_label: "最適化評価",
        download_label: "ダウンロード",
        share_label: "공유하기",
        status_success: "成功",
        status_optimizing: "最適化中",
        status_fail: "失敗",

        expire_days: "{0}日後に期限切れ",
        reset_expire_days: "{0}日後にリセット",
        reset_expire_day: "{0}日後にリセット",
        avg_reduction_info: "頂点数平均{0}% 削減",
        avg_rating_info: "最適化評価{0}件基準",

        count_label: "クレジット",

    },
};
